import { Group, Menu, Text } from '@mantine/core';
import { openModal } from '@mantine/modals';
import {
  IconKey,
  IconLogout,
  IconMenu2,
  IconUser,
  IconUserCircle,
} from '@tabler/icons-react';

import useAuth from '@hooks/useAuth';

import EditUserForm from '@components/users/EditUserForm';
import EditUserPasswordForm from '@components/users/EditUserPasswordForm';

import logo from '@assets/images/logo.png';

import classes from './Header.module.css';

interface HeaderProps {
  onHamburgerClick: () => void;
}

export default function Header({ onHamburgerClick }: HeaderProps) {
  const { logout } = useAuth();

  const handleEditUserClick = () => {
    openModal({
      title: 'Modifica profilo',
      children: <EditUserForm />,
    });
  };

  const handleEditPasswordClick = () => {
    openModal({
      title: 'Modifica password',
      children: <EditUserPasswordForm />,
    });
  };

  return (
    <header className={classes.header}>
      <Group justify="space-between">
        <img src={logo} alt="Painzero" className={classes.logo} />

        <Group>
          <Menu withArrow>
            <Menu.Target>
              <IconUserCircle size="2rem" />
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={handleEditUserClick}>
                <Group>
                  <IconUser size="1.5rem" color="#2f2f2f" />
                  <Text c="black" size="sm">
                    Modifica profilo
                  </Text>
                </Group>
              </Menu.Item>
              <Menu.Item onClick={handleEditPasswordClick}>
                <Group>
                  <IconKey size="1.5rem" />
                  <Text size="sm">Modifica password</Text>
                </Group>
              </Menu.Item>
              <Menu.Item onClick={logout} c="red">
                <Group>
                  <IconLogout size="1.5rem" />
                  <Text size="sm">Logout</Text>
                </Group>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          <IconMenu2
            size="2.1rem"
            style={{ cursor: 'pointer' }}
            onClick={onHamburgerClick}
            color="#2f2f2f"
          />
          {/* <IconBadge
            tooltipLabel="Notifiche"
            badgeText={
              notificationsCount.count !== 0
                ? notificationsCount.count.toString()
                : null
            }
            to="/notifiche"
          /> */}
        </Group>
      </Group>
    </header>
  );
}
